import View from "./View";

const EmptyView = View.extend(
  /** @lends EmptyView.prototype */
  {
    /**
     * Simple view for the big clickable empty space shown when no items are present.
     * Emits click events. Doesn't automatically show/hide when items change.
     * @param {UploaderModel} model
     * @param {object} opts
     * @param {string} opts.emptyMessageHeading - template place ##heading##
     * @param {string} opts.emptyMessageText    - template place ##text##
     * @constructs
     * @extends View
     */
    constructor(model, opts) {
      View.call(this, model, opts);

      this.setHTML(this.opts.template.parse("empty", {
        id: this.id,
        heading: this.opts.emptyMessageHeading,
        text: this.opts.emptyMessageText,
        enable_capture: this.opts.enable_capture
      }));
    },

    onMount() {
      const btnEl = this.getElement("empty_button");
      this.forwardEvent(btnEl, "click");

      const captureBtnEl = this.getElement("empty_button_capture");
      if (captureBtnEl) this.forwardEvent(captureBtnEl, "click", "capture");
    }
  });

export default EmptyView;
